export interface DhikrHadith {
  title: string;
  text: string;
  source: string;
}

export const DHIKR_HADITHS: DhikrHadith[] = [
  {
    title: 'ذكر الله حياة القلوب',
    text: 'مَثَلُ الَّذِي يَذْكُرُ رَبَّهُ وَالَّذِي لَا يَذْكُرُ رَبَّهُ، مَثَلُ الْحَيِّ وَالْمَيِّتِ.',
    source: 'صحيح البخاري (6407)',
  },
  {
    title: 'خير الأعمال',
    text: 'أَلَا أُنَبِّئُكُمْ بِخَيْرِ أَعْمَالِكُمْ، وَأَزْكَاهَا عِنْدَ مَلِيكِكُمْ، وَأَرْفَعِهَا فِي دَرَجَاتِكُمْ، وَخَيْرٍ لَكُمْ مِنْ إِنْفَاقِ الذَّهَبِ وَالْوَرِقِ، وَخَيْرٍ لَكُمْ مِنْ أَنْ تَلْقَوْا عَدُوَّكُمْ فَتَضْرِبُوا أَعْنَاقَهُمْ وَيَضْرِبُوا أَعْنَاقَكُمْ؟ قَالُوا: بَلَى. قَالَ: ذِكْرُ اللَّهِ تَعَالَى.',
    source: 'سنن الترمذي (3377)',
  },
  {
    title: 'السابقون إلى الذكر',
    text: 'سَبَقَ الْمُفَرِّدُونَ. قالوا: وَمَا الْمُفَرِّدُونَ يَا رَسُولَ اللَّهِ؟ قال: الذَّاكِرُونَ اللَّهَ كَثِيرًا وَالذَّاكِرَاتُ.',
    source: 'صحيح مسلم (2676)',
  },
  {
    title: 'مجالس الذكر تحفها الملائكة',
    text: 'لَا يَقْعُدُ قَوْمٌ يَذْكُرُونَ اللَّهَ عَزَّ وَجَلَّ إِلَّا حَفَّتْهُمُ الْمَلَائِكَةُ، وَغَشِيَتْهُمُ الرَّحْمَةُ، وَنَزَلَتْ عَلَيْهِمُ السَّكِينَةُ، وَذَكَرَهُمُ اللَّهُ فِيمَنْ عِنْدَهُ.',
    source: 'صحيح مسلم (2700)',
  },
  {
    title: 'فضل الاجتماع لذكر الله',
    text: 'إِنَّ لِلَّهِ مَلَائِكَةً يَطُوفُونَ فِي الطُّرُقِ، يَلْتَمِسُونَ أَهْلَ الذِّكْرِ...',
    source: 'صحيح البخاري (6408)، وصحيح مسلم (2689)',
  },
  {
    title: 'كلمتان عظيمتان في الميزان',
    text: 'كَلِمَتَانِ خَفِيفَتَانِ عَلَى اللِّسَانِ، ثَقِيلَتَانِ فِي الْمِيزَانِ، حَبِيبَتَانِ إِلَى الرَّحْمَنِ: سُبْحَانَ اللَّهِ وَبِحَمْدِهِ، سُبْحَانَ اللَّهِ الْعَظِيمِ.',
    source: 'صحيح البخاري (6406)، وصحيح مسلم (2694)',
  },
  {
    title: 'أحب الكلام إلى الله',
    text: 'أَحَبُّ الْكَلَامِ إِلَى اللَّهِ أَرْبَعٌ: سُبْحَانَ اللَّهِ، وَالْحَمْدُ لِلَّهِ، وَلَا إِلَهَ إِلَّا اللَّهُ، وَاللَّهُ أَكْبَرُ، لَا يَضُرُّكَ بِأَيِّهِنَّ بَدَأْتَ.',
    source: 'صحيح مسلم (2137)',
  },
  {
    title: 'غراس الجنة',
    text: 'لَقِيتُ إِبْرَاهِيمَ لَيْلَةَ أُسْرِيَ بِي، فَقَالَ: يَا مُحَمَّدُ، أَقْرِئْ أُمَّتَكَ مِنِّي السَّلَامَ، وَأَخْبِرْهُمْ أَنَّ الْجَنَّةَ طَيِّبَةُ التُّرْبَةِ، عَذْبَةُ الْمَاءِ، وَأَنَّهَا قِيعَانٌ، وَأَنَّ غِرَاسَهَا: سُبْحَانَ اللَّهِ، وَالْحَمْدُ لِلَّهِ، وَلَا إِلَهَ إِلَّا اللَّهُ، وَاللَّهُ أَكْبَرُ.',
    source: 'سنن الترمذي (3462)، وحسنه أهل العلم',
  },
  {
    title: 'سبحان الله وبحمده مائة مرة',
    text: 'مَنْ قَالَ: سُبْحَانَ اللَّهِ وَبِحَمْدِهِ، فِي يَوْمٍ مِائَةَ مَرَّةٍ، حُطَّتْ خَطَايَاهُ، وَإِنْ كَانَتْ مِثْلَ زَبَدِ الْبَحْرِ.',
    source: 'صحيح البخاري (6405)، وصحيح مسلم (2691)',
  },
  {
    title: 'فضل لا إله إلا الله وحده لا شريك له',
    text: 'مَنْ قَالَ: لَا إِلَهَ إِلَّا اللَّهُ وَحْدَهُ لَا شَرِيكَ لَهُ، لَهُ الْمُلْكُ وَلَهُ الْحَمْدُ، وَهُوَ عَلَى كُلِّ شَيْءٍ قَدِيرٌ، فِي يَوْمٍ مِائَةَ مَرَّةٍ، كَانَتْ لَهُ عَدْلَ عَشْرِ رِقَابٍ، وَكُتِبَتْ لَهُ مِائَةُ حَسَنَةٍ، وَمُحِيَتْ عَنْهُ مِائَةُ سَيِّئَةٍ، وَكَانَتْ لَهُ حِرْزًا مِنَ الشَّيْطَانِ يَوْمَهُ ذَلِكَ حَتَّى يُمْسِيَ.',
    source: 'صحيح البخاري (3293)، وصحيح مسلم (2691)',
  },
];
